<template>
  <div>
    <div v-show="showEnableNotification" class="notification-banner">
      {{ $t("notificationBanner.allowMessage") }}
    </div>
    <div
      v-if="totalNotifications > 0"
      class="notification-container d-flex flex-column p-4"
    >
      <div class="d-flex flex-row justify-content-between">
        <span class="notification-counter">1/{{ totalNotifications }}</span>
        <span>
          <smtt-icon
            icon="close"
            class="d-flex justify-content-end close-button"
            role="button"
            @click="onNotificationClose"
          />
        </span>
      </div>
      <div class="notification-body">
        <div class="font-weight-bold">
          {{ lastNotification.notification.title }}
        </div>
        <div>{{ lastNotification.notification.body }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Notifications",
  computed: {
    ...mapGetters({
      lastNotification: "GetLastPushNotification",
      totalNotifications: "GetPushNotificationCount",
    }),
  },
  data() {
    return {
      showEnableNotification: false,
    };
  },
  methods: {
    ...mapActions(["removePushNotification"]),
    onNotificationClose() {
      this.removePushNotification();
    },
  },
  mounted() {
    if ("Notification" in window) {
      if (Notification.permission === "default") {
        this.showEnableNotification = true;
        setTimeout(() => {
          this.showEnableNotification = false;
        }, 5000);
      } else {
        this.showEnableNotification = false;
      }
    }
  },
};
</script>

<style scoped>
.notification-banner {
  background-color: var(--warning);
  text-align: center;
  padding: 10px;
  transition: all 0.5s ease;
}

.notification-container {
  color: white;
  position: fixed;
  z-index: 51;
  background-color: var(--primary);
  border-radius: 0.2rem;
  top: 20px;
  right: 20px;
  width: 180px;
}

.notification-body {
  margin-top: 10px;
}

.notification-counter {
  opacity: 0.5;
  font-size: 12px;
}

.close-button:hover {
  cursor: pointer;
}
</style>
